import { Component, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { ErrorStateMatcher } from "@angular/material/core";
import { FormControl } from "@angular/forms";
import { ResetPasswordService } from '../../services/reset-password.service';

import { ActivatedRoute, Router } from '@angular/router';

import { MyErrorStateMatcher } from '../../shared/my-error-state-matcher.class';

import { StrongPasswordRegx } from '../../shared/strong-password-reg-exp.const';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-reset-password',
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        CommonModule
    ],
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnInit {

    private token: string = "";
    matcher = new MyErrorStateMatcher();


    public newPasswordForm: FormGroup = new FormGroup({
        password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(StrongPasswordRegx)]),
        password_confirm: new FormControl('', [Validators.required]),
    });

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        private resetPasswordService: ResetPasswordService
    ) {

    }

    ngOnInit(): void {
        console.log("reset password")

        const fullToken = this.route.snapshot.params['token'];

        const tokenParts = fullToken.split("|");

        //this.token = this.route.snapshot.params['token'];

        console.log("tokenParts", tokenParts)
        this.token = tokenParts[1];

        console.log("token", this.token)
    }

    onSubmit() {
        this.resetPasswordService.changePassword(this.token, this.newPasswordForm.value.password, this.newPasswordForm.value.password_confirm)
            .subscribe({
                next: (data: any) => {
                    console.log(data);
                    if (data.status === "success") {
                        this.router.navigate(['/login']);
                    }
                },
                error: (error: any) => {
                    console.error(error);
                }
            });
    }

}
